import React from 'react';
import { CameraIcon } from 'lucide-react';
type PhotoPlaceholderProps = {
  description: string;
  alt: string;
  supplySize: string;
  src?: string;
  variant?: 'block' | 'background';
  className?: string;
};

/**
 * Clearly marked image slot. When the client supplies a photo, pass `src`
 * and it renders as a real image with the same alt text.
 */
export function PhotoPlaceholder({
  description,
  alt,
  supplySize,
  src,
  variant = 'block',
  className = ''
}: PhotoPlaceholderProps) {
  if (src) {
    return <img src={src} alt={alt} className={`h-full w-full object-cover ${className}`} data-id="element-83" data-mp="3ak0st433m34k" />;
  }
  if (variant === 'background') {
    return <div role="img" aria-label={alt} className={`h-full w-full bg-navy-soft ${className}`} data-id="element-84" data-mp="3ffzbqc5nqsxl">
        <div className="absolute bottom-4 right-4 z-20 hidden max-w-xs rounded-sm border border-dashed border-paper/40 bg-navy-deep/80 px-3 py-2 text-xs leading-snug text-paper/80 md:block" data-id="element-85" data-mp="3ka3kn0yhhb1b">
          <span className="font-semibold text-paper" data-id="element-86" data-mp="2rqn4vixsywyg">Photo placeholder:</span> {description}
          <span className="mt-1 block text-paper/60" data-id="element-87" data-mp="1ror0zwjy90jy">Supply at {supplySize}</span>
        </div>
      </div>;
  }
  return <div role="img" aria-label={alt} className={`flex h-full w-full flex-col items-center justify-center gap-3 border-2 border-dashed border-navy/25 bg-[#E9E4DA] p-8 text-center ${className}`} data-id="element-88" data-mp="1msiefy3fa52r">
      <CameraIcon aria-hidden="true" className="h-8 w-8 text-navy/50" strokeWidth={1.5} data-id="element-89" data-mp="18yrcbas0tnh2" />
      <p className="text-sm font-semibold uppercase tracking-wider text-navy/70" data-id="element-90" data-mp="13zo97vvlprbq">Photo placeholder</p>
      <p className="max-w-xs text-base leading-snug text-charcoal/80" data-id="element-91" data-mp="z0lfh7l2n7j2">{description}</p>
      <p className="text-sm text-charcoal/60" data-id="element-92" data-mp="z2eo2sf8w1tp">Supply at {supplySize}</p>
    </div>;
}